// yyyy-mm-dd, matches the <input type="date"> format used by FilterBar.
const isValidDateString = (value) => /^\d{4}-\d{2}-\d{2}$/.test(value) && !Number.isNaN(new Date(value).getTime());

const toDateString = (d) => {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
};

// "This week" = Sunday through today's date, matching DEFAULT_SHORTCUTS'
// "This week" entry (dayjs startOf('week') is Sunday by default).
const getThisWeekRange = () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    start.setDate(start.getDate() - start.getDay()); // back up to Sunday
    const end = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    return { from: toDateString(start), to: toDateString(end) };
};

// Reads { customRange } out of the current URL's query string.
// Never trusts the URL blindly -- a malformed date falls back to the
// default ("this week") rather than being passed downstream.
// If the URL has no from/to at all, defaults to "this week" instead of
// an empty range, so the initial view/state/fetch are consistent with
// what's shown once a filter is picked.
export function readFiltersFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const from = params.get("from");
    const to = params.get("to");

    if ((from && isValidDateString(from)) || (to && isValidDateString(to))) {
        return {
            customRange: {
                from: from && isValidDateString(from) ? from : "",
                to: to && isValidDateString(to) ? to : "",
            },
        };
    }

    return {
        customRange: getThisWeekRange(),
    };
}

// Writes the current filter selection back into the URL (replacing history,
// not pushing a new entry) so a refresh restores the same view.
export function writeFiltersToUrl({ customRange }) {
    const params = new URLSearchParams(window.location.search);

    params.delete("from");
    params.delete("to");

    if (customRange?.from) params.set("from", customRange.from);
    if (customRange?.to) params.set("to", customRange.to);

    const query = params.toString();
    const newUrl = `${window.location.pathname}${query ? `?${query}` : ""}${window.location.hash}`;
    window.history.replaceState(window.history.state, "", newUrl);
}